<template>
  <div>
    <h1>{{ $t('enrollmentStep.wrongStudy.sorry') }}</h1>

    <div v-if="isParticipant">
      <p class="lead">
        {{ $t('enrollmentStep.wrongStudy.inDifferentProgram') }}
      </p>
      <a href="/" class="btn btn-primary btn-lg">{{ $t('enrollmentStep.wrongStudy.takeMeToMyProgram') }}</a>
    </div>

    <div v-else>
      <p class="lead">
        {{ $t('enrollmentStep.wrongStudy.loggedAsAdmin') }}
      </p>
      <p class="lead">
        {{ $t('enrollmentStep.wrongStudy.viewAsParticipant') }}
      </p>
      <a :href="enrollmentUrl" class="btn btn-primary btn-lg">{{ $t('enrollmentStep.wrongStudy.viewEnrollment') }}</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      studyId: {
        type: Number,
        required: true
      },
      account: {
        type: Object,
        required: true 
      }
    },
    computed: {
      enrollmentUrl() {
        return `${this.$baseUrl ? this.$baseUrl : ''}/${this.$studySlug}/enroll`;
      },
      isParticipant() {
        // returns true if account has any study users that are participants
        return this.account.StudyUsers.findIndex((su) => su.role === 'Participant') >= 0;
      }
    },
    created() {
      this.$emit('ready');
    }
  }
</script>